module.exports = __webpack_public_path__ + "media/flags/kz-a8b78e86.svg";